import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=1adbf84a&"
import script from "../../scripts/KeyboardLists/ChannelList.js?vue&type=script&lang=js&"
export * from "../../scripts/KeyboardLists/ChannelList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports